/**
 * Le clavier d'une rangée d'onglets (pur) : ce que la flèche ouvre, et qui est l'arrêt de tabulation.
 * Lu par `<Tabs>` ; testé à côté, la story ne pouvant pas montrer ce que le clavier fait.
 */

/** Un onglet, vu du clavier : sa clé, et s'il se touche. */
export type TabStop<K extends string> = { key: K; disabled?: boolean }

/**
 * L'onglet qu'ouvre une flèche (1 : droite, -1 : gauche), en sautant les onglets désactivés et en
 * bouclant aux bords. `null` quand il n'y a nulle part où aller (aucun autre onglet actif).
 */
export function nextTab<K extends string>(items: TabStop<K>[], value: K, direction: 1 | -1): K | null {
    const enabled = items.filter((item) => item.disabled !== true)
    if (enabled.length === 0) return null
    const index = enabled.findIndex((item) => item.key === value)
    // L'onglet ouvert n'est pas parmi les actifs : la flèche part du bord.
    const from = index === -1 ? (direction === 1 ? -1 : 0) : index
    const next = enabled[(from + direction + enabled.length) % enabled.length]
    return next == null || next.key === value ? null : next.key
}

/** Un seul arrêt de tabulation par rangée, l'onglet ouvert : les flèches font le reste (le motif ARIA). */
export function tabStopIndex(selected: boolean): 0 | -1 {
    return selected ? 0 : -1
}
